import { TransactionsTable } from './components/TransactionsTable';

export const Transactions = () => {
  return (
    <div>
      <TransactionsTable />
    </div>
  );
};
